import React from "react";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import StepConnector from "@material-ui/core/StepConnector";
import { connect } from "react-redux";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";

import AddEventIcon from "@material-ui/icons/AddCircleOutline";
import LoginIcon from "@material-ui/icons/ExitToApp";
import ChangeEventIcon from "@material-ui/icons/BorderColor";
import ConfirmEventIcon from "@material-ui/icons/DoneOutline";
import { createSelector } from "reselect";

import { getPersonHistory } from "../../../../store/actions";

const CHANGE_EVENT = 1;
const ADD_EVENT = 2;
const CONFIRM_EVENT = 3;
const LOGIN_EVENT = 4;

const EVENT_TYPES_ICONS_MAP = {
    [CHANGE_EVENT]: ChangeEventIcon,
    [ADD_EVENT]: AddEventIcon,
    [CONFIRM_EVENT]: ConfirmEventIcon,
    [LOGIN_EVENT]: LoginIcon
};

const eventsHistory = state => state.persons.history;

const historyDataSelector = createSelector(eventsHistory, events => {
    const groupedDataMap = new Map();
    const monthYearGroupsKeys = [];
    if (events !== undefined) {
        events.forEach(event => {
            const monthYearKey = moment(event.timestamp).format("YYYY-MM");
            let group = groupedDataMap.get(monthYearKey);
            if (!group) {
                group = [];
                groupedDataMap.set(monthYearKey, group);
                monthYearGroupsKeys.push(monthYearKey);
            }
            group.push(event);
        });
    }
    return { monthYearGroupsKeys, groupedDataMap };
});

const useStyles = makeStyles(theme => ({
    root: {
        display: "flex",
        flexWrap: "wrap",
        backgroundColor: "#FFF"
    },
    stepIcon: {
        width: 16,
        height: 16,
        border: "2px solid #F15454",
        borderRadius: "50%"
    },
    eventIcon: {
        marginRight: theme.spacing(3)
    },
    stepLabel: {
        display: "flex",
        fontSize: 14,
        lineHeight: "17px",
        marginLeft: theme.spacing(3)
    },
    eventTime: {
        color: "#7E7E7E",
        marginTop: 6
    },
    eventDate: {
        marginRight: 30,
        marginTop: 6
    },
    eventType: {
        display: "flex",
        color: "#93A7BE",
        alignItems: "baseline"
    },
    eventTypeName: {
        marginLeft: theme.spacing(2),
        marginBottom: theme.spacing()
    },
    eventDescription: {
        marginLeft: 36
    },
    stepContent: {
        marginTop: "-8px",
        marginLeft: "8px",
        paddingLeft: "101px",
        paddingRight: "8px",
        borderColor: "#DC4E41",
        paddingTop: "8px",
        paddingBottom: "24px"
    },
    stepConnector: {
        marginLeft: "8px",
        marginBottom: "-16px"
    },
    stepConnectorLine: {
        borderColor: "#DC4E41"
    },
    eventsGroup: {
        padding: `${theme.spacing(2)}px ${theme.spacing(1)}px`,
        color: "#D0101B",
        fontSize: "14px"
    }
}));

const StepIcon = props => {
    const classes = useStyles();
    return <div className={classes.stepIcon} />;
};

const EventIcon = props => {
    const classes = useStyles();
    const EventIcon = EVENT_TYPES_ICONS_MAP[props.type];
    if (EventIcon === undefined) return <div className={classes.eventIcon} />;

    return (
        <div>
            <EventIcon fontSize="small" />
        </div>
    );
};

const MONTHS_MAP = {
    "01": "Январь",
    "02": "Февраль",
    "03": "Март",
    "04": "Апрель",
    "05": "Май",
    "06": "Июнь",
    "07": "Июль",
    "08": "Август",
    "09": "Сентябрь",
    "10": "Октябрь",
    "11": "Ноябрь",
    "12": "Декабрь"
};

const EventsGroup = props => {
    const classes = useStyles();
    const { groupKey } = props;
    const [Y, M] = groupKey.split("-");
    return (
        <div className={classes.eventsGroup}>{`${MONTHS_MAP[M]}, ${Y}`}</div>
    );
};

// [ {
//     "type" : 1,
//     "typeName" : "Изменение данных",
//     "description" : "Модификация ролей",
//     "timestamp" : "2019-09-10T12:00:00Z"
//   } ]

const History = ({ historyData, getPersonHistory }) => {
    const classes = useStyles();
    const { monthYearGroupsKeys, groupedDataMap } = historyData;

    React.useEffect(() => {
      getPersonHistory();
    }, []);

    return (
        <div className={classes.root}>
            {monthYearGroupsKeys.map(key => (
                <div key={key}>
                    <EventsGroup groupKey={key} />
                    <Stepper
                        orientation="vertical"
                        connector={
                            <StepConnector
                                classes={{
                                    vertical: classes.stepConnector,
                                    lineVertical: classes.stepConnectorLine
                                }}
                            />
                        }
                    >
                        {groupedDataMap.get(key).map(event => (
                            <Step key={event.timestamp} active={true}>
                                <StepLabel StepIconComponent={StepIcon}>
                                    <div className={classes.stepLabel}>
                                        <div className={classes.eventDate}>
                                            {moment(event.timestamp).format(
                                                "DD.MM"
                                            )}
                                        </div>
                                        <div>
                                            <div className={classes.eventType}>
                                                {
                                                    <EventIcon
                                                        type={event.type}
                                                    />
                                                }
                                                <div
                                                    className={
                                                        classes.eventTypeName
                                                    }
                                                >
                                                    {event.typeName}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </StepLabel>
                                <StepContent className={classes.stepContent}>
                                    <div className={classes.eventDescription}>
                                        <div>{event.description}</div>
                                        <div className={classes.eventTime}>
                                            {moment(event.timestamp).format(
                                                "HH:mm"
                                            )}
                                        </div>
                                    </div>
                                </StepContent>
                            </Step>
                        ))}
                    </Stepper>
                </div>
            ))}
        </div>
    );
};

const mapStateToProps = state => ({
    historyData: historyDataSelector(state)
});

const mapDispatchToProps = dispatch => ({
  getPersonHistory: () => dispatch(getPersonHistory())
});

export default connect(mapStateToProps, mapDispatchToProps)(History);
